// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"732":"231f7d0d","977":"c92b4a87"}[chunkId] + ".chunk.js");